import Store from '../general/store'

export interface Data {
  x: string
  y: number | null
  ymax: number | null
}

class Insight<T extends Data = Data, S = any> extends Store<S> {
  readonly data: T

  constructor(parent: S, data: T) {
    super(parent)
    this.data = data
  }

  get label() {
    return this.data.x
  }

  get value() {
    return this.data.y
  }

  get peak() {
    return this.data.ymax
  }
}

export default Insight
